import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAuthorizationRequest, } from "../../Authorizations/interfaces/Interfaces";
import { baseUrl } from "../../config/Config";
import { getApiCall } from "../../ApiHelper";
import { Documents } from "../../Authorizations/interfaces/Interfaces";

type InitialState = {
    documents: Documents | null,
    error: string,
    loading: boolean,
    uploadingDocuments: boolean,
    remainingAttachments: any
}

const initialState: InitialState = {
    documents: null,
    error: '',
    loading: false,
    uploadingDocuments:false,
    remainingAttachments: {} as any
}

export const getAllDocuments = createAsyncThunk("getAllDocuments", async (payload:any, {rejectWithValue}) => {
    try {
        var url = `${baseUrl}Document/GetAllDocument?authId=${payload}`;
        const response = await getApiCall<Documents>(url);
        return response;
    } catch (error: any) {
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})`||error.message);
    }
})

const documentSlice = createSlice({
    name: 'allDocumentData',
    initialState,
    reducers: {
        uploadingDocuments(state, action){
            state.uploadingDocuments = action.payload
        },
        remainingAttachments(state, action){
            state.remainingAttachments = action.payload
        }
    },
    extraReducers: (builder) => {
            builder.addCase(getAllDocuments.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllDocuments.fulfilled, (state, action: PayloadAction<Documents | null>) => {
                state.loading = false;
                state.documents = action.payload;
            })
            .addCase(getAllDocuments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'something went wrong';
            })
    }
});

export const getAllDocumentData = (state:any) => state.documentData.documents
export const {uploadingDocuments, remainingAttachments} = documentSlice.actions;
export default documentSlice.reducer;
